import { usePortfolioCalls } from 'hooks/calls'
import { BigNumber } from 'ethers'
import { StructuredOffering } from 'types/Portfolio/StructuredOffering'
import { SupportedChainId } from 'constants/chain'

export function useTotalAssets(portfolios: StructuredOffering[], chainId: SupportedChainId | undefined) {
  const addresses = portfolios.map((portfolio) => portfolio.address)
  return usePortfolioCalls<BigNumber>(chainId, addresses, 'totalAssets', [], !portfolios.length || !chainId)
}
